import { render, staticRenderFns } from "./IncidentDetailsView.vue?vue&type=template&id=810b0bf8&scoped=true&"
import script from "./IncidentDetailsView.vue?vue&type=script&lang=js&"
export * from "./IncidentDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./IncidentDetailsView.vue?vue&type=style&index=0&id=810b0bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810b0bf8",
  null
  
)

export default component.exports